import { testBalanceInstances, dynamicInstances, useParamsUrlInstances, axiosInstance, live_instance } from "../instance";
import { getBaseUrl } from "@/utils";

/** ==============================直播跟踪调试====================================== */

/**testBalance */
export const testBalanceApi = (userid) => dynamicInstances({method: 'get', url: `/balance/getAAAServer`, params:{userid,}})

/** testAAA 登录 */
export const traceLoginApi = (params) => dynamicInstances({method: 'get', url: `/aaa/ott/login`, params})

/** testIndex 这个接口可以拿到获取二级分类的url*/
//export const testIndexApi = (params) => dynamicInstances({method: 'get', url: '/epgserver/index/index', params})
export const testIndexApi = (params, url) => useParamsUrlInstances({method: 'get', url, params})

/** testAgent 获取一级分类 */
//export const testAgentApi = (usertoken) => dynamicInstances({method: 'get', url: '/agent/agent', params:{1:1, usertoken}})
export const testAgentApi = (url) => useParamsUrlInstances({method: 'get', url})

/**获取二级分类 */
export const getSubCategoryApi = (url) => useParamsUrlInstances({method: 'get', url})

/** 获取分类列表 */
export const getTraceChannelListApi = (params, url) => dynamicInstances({method: 'get', url, params})

/** 获取history列表 */
export const getHistoryListApi = (params, url) => dynamicInstances({method: 'get', url, params})

/** 获取favorite列表 */
export const getFavouritesListApi = (params, url) => dynamicInstances({method: 'get', url, params})

/** 获取netAudio列表 */
export const getNetAudioList2Api = (params,url) => dynamicInstances({method: 'get', url, params})

/** 根据SN获取3id */
export const get3IdfromSNApi = (params,url) => dynamicInstances({method: 'get', url, params})

/** 获取aaa选项 */
export const getAaaOptionApi = (url) => dynamicInstances({method: 'get', url})

/** 获取authInfo */
export const getAuthinfoApi = (params,url, usertoken) => dynamicInstances({method: 'get', url, params, headers:{usertoken }})

/** 获取cookie */
export const getCookieApi = (params,url, usertoken) => dynamicInstances({method: 'get', url, params, headers:{usertoken }})


/**=======================================================账号查询/日志查询==================================================================== */
/**通过sn获取客户、平台、型号信息 */
export const getInfoBySnApi = (params) => axiosInstance({method: 'get', url: `/api/sn/getSnModelName`, params })

/** 查询sn  */
export const getSnRecordApi = (params) => {
  return live_instance({method: 'get', url: `/api/sn/record`, params })
}

let beforeURL = ''
/** 账号|SN|激活码查询 */
export const getAccountInfoApi = (operateType, keyWord) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/maintenance/info/getAccountInfo`, params:{operateType, keyWord} })

/**日志查询 */
export const getLogListApi = (params) => live_instance({method: 'post', url:`${beforeURL}/live/api/web/maintenance/info/getLogInfo`, data:params, type:'json'})


/**=======================================================盒端截图==================================================================== */

export const getModelScreenshotApi = (params) => live_instance({method: 'get', url: `${beforeURL}/live/api/web/screenshot/listImage`, params })

export const toScreenshotApi = (params) => live_instance({method: 'post', url: `${beforeURL}/live/api/web/screenshot`, params })




